import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Note } from "../components/Note";
import { API } from "../core/api";
import { Form } from "antd";
import {
  toEnglishNumber,
  onChangeProvince,
  formatAntdJalaliDate,
} from "../core/utils";
import { useHistory, useLocation } from "react-router-dom";
import { parse, stringify } from "query-string";
import FileSaver from "file-saver";
const useCredit = ({ setIsModalOpen }) => {
  const provinces = useSelector((state) => state.Store.provinces);
  const location = useLocation();
  const params = parse(location.search);

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [creditsData, setCreditsData] = useState([
    {
      id: 2405261,
      amount: 10000,
      user: {
        fullname: "Mohammed Al-Saud",
      },
      created_at: "1402/03/01",
      current_total_amount: 9000,
      city: [
        {
          city: "Riyadh",
          province: "Riyadh",
        },
      ],
    },
    {
      id: 2402009,
      amount: 595000,
      user: {
        fullname: "Fatima Al-Ghamdi",
      },
      created_at: "1402/02/31",
      current_total_amount: 440000,
      city: [
        {
          city: "Riyadh",
          province: "Riyadh",
        },
      ],
    },
    {
      id: 2401923,
      amount: 50000,
      user: {
        fullname: "Ahmad Al-Zahrani",
      },
      created_at: "1402/02/31",
      current_total_amount: 10000,
      city: [
        {
          city: "Mecca",
          province: "Mecca",
        },
      ],
    },
  ]);

  const [search, setSearch] = useState(params.search || "");
  const [users, setUsers] = useState([]);
  const history = useHistory();
  const [increaseCreditState, setIncreaseCreditState] = useState({
    province_id: null,
    city_id: null,
    user_id: null,
    amount: "",
  });

  const getCredits = (page, disableFilters = false, get_report) => {
    // setLoading(true);
    const formItems = form.getFieldsValue();
    const form_created_start_date =
      formItems.created_date.length &&
      formItems.created_date[0] &&
      typeof formItems.created_date[0] === "object"
        ? formatAntdJalaliDate(formItems.created_date[0])
        : formItems.created_date
        ? formItems.created_date[0]
        : null;

    const form_created_end_date =
      formItems.created_date.length &&
      formItems.created_date[1] &&
      typeof formItems.created_date[1] === "object"
        ? formatAntdJalaliDate(formItems.created_date[1])
        : formItems.created_date
        ? formItems.created_date[1]
        : null;

    const filters = {
      search,
      ...((page || creditsData?.pagination?.page) && {
        page: page || creditsData?.pagination?.page,
      }),
      province_id: formItems.province_id,
      city_id: formItems.city_id,
      user_id: formItems.user_id,
      created_start_date: form_created_start_date,
      created_end_date: form_created_end_date,
      get_report,
    };

    if (!disableFilters)
      history.push({ pathname: "/credit/", search: stringify(filters) });

    // API.get
    //   .credit(disableFilters ? {} : filters)
    //   .then((response) => {
    //     setLoading(false);

    //     if (response.success) {
    //       if (!get_report) setCreditsData(response);
    //     } else {
    //       Note.error(response.message);
    //     }
    //   })
    //   .catch(() => {
    //     setLoading(false);
    //   });
  };

  const increaseCredit = () => {
    if (!increaseCreditState.province_id) {
      return Note.error("لطفا استان را انتخاب کنید");
    }

    if (!increaseCreditState.city_id) {
      return Note.error("لطفا شهر را انتخاب کنید");
    }

    if (!increaseCreditState.user_id) {
      return Note.error("لطفا کاربر موردنظر را انتخاب کنید");
    }
    if (!increaseCreditState.amount) {
      return Note.error("لطفا اعتبار را وارد کنید");
    }

    // API.post
    //   .add_credit({
    //     province_id: increaseCreditState.province_id,
    //     city_id: increaseCreditState.city_id,
    //     amount: Number(toEnglishNumber(increaseCreditState.amount)) * 10,
    //     user_id: increaseCreditState.user_id,
    //   })
    //   .then((response) => {
    //     if (response.success) {
    //       Note.success(response.message);
    //       setIsModalOpen(false);
    //       handleChangeIncreaseCreditState({
    //         province_id: null,
    //         city_id: null,
    //         amount: "",
    //         user_id: null,
    //       });
    //       getCredits();
    //     } else {
    //       Note.error(response.message);
    //     }
    //   });
  };

  const exportCredits = () => {
    const formItems = form.getFieldsValue();
    const form_created_start_date =
      formItems.created_date.length &&
      formItems.created_date[0] &&
      typeof formItems.created_date[0] === "object"
        ? formatAntdJalaliDate(formItems.created_date[0])
        : formItems.created_date
        ? formItems.created_date[0]
        : null;

    const form_created_end_date =
      formItems.created_date.length &&
      formItems.created_date[1] &&
      typeof formItems.created_date[1] === "object"
        ? formatAntdJalaliDate(formItems.created_date[1])
        : formItems.created_date
        ? formItems.created_date[1]
        : null;

    const filters = {
      search,
      ...(creditsData?.pagination?.page && {
        page: creditsData?.pagination?.page,
      }),
      province_id: formItems.province_id,
      city_id: formItems.city_id,
      user_id: formItems.user_id,
      created_start_date: form_created_start_date,
      created_end_date: form_created_end_date,
      get_report: true,
    };

    // API.get
    //   .export_credit(filters)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       return response.blob();
    //     } else {
    //       Note.error(response.message);
    //     }
    //   })
    //   .then((blob) => {
    //     FileSaver.saveAs(blob, `credits-report.xlsx`);
    //   });
  };

  const handleChangeIncreaseCreditState = (data) => {
    setIncreaseCreditState({
      ...increaseCreditState,
      ...data,
    });
  };

  const onChangeAmount = (amount) => {
    const newAmount = amount.replace(/,/g, "");
    handleChangeIncreaseCreditState({
      amount: newAmount,
    });
  };

  const changePage = (page) => {
    setCreditsData({
      ...creditsData,
      pagination: {
        ...creditsData?.pagination,
        page,
      },
    });
    getCredits(page);
  };

  const getUsers = (province_id, city_id) => {
    console.log(province_id, city_id);
    const filters = {
      province_id: province_id ? province_id : null,
      city_id: city_id ? city_id : null,
    };

    // API.get
    //   .company_employee(filters)
    //   .then((response) => {
    //     if (response.success) {
    //       setUsers(response.data);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };
  useEffect(() => {
    getCredits();
    getUsers();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (params.province_id && !cities.length) {
      onChangeProvince(params.province_id, null, setCities);
    }
    // eslint-disable-next-line
  }, [history]);

  return {
    loading,
    provinces,
    cities,
    setCities,
    users,
    setUsers,
    onChangeAmount,
    increaseCredit,
    creditsData,
    getCredits,
    form,
    increaseCreditState,
    handleChangeIncreaseCreditState,
    search,
    setSearch,
    changePage,
    getUsers,
    exportCredits,
  };
};

export default useCredit;
